import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export function useLaravelEcho() {

    const echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_APP_KEY,
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        forceTLS: true
    });

    return echo;
}